<template>
  <section class="report-section" v-if="show_all">
    <h3>{{ index }}.3 Ripartizione consumi {{ vectorName }}</h3>

    <div v-for="(category) in categories" :key="category.value">
      <div v-show="category.show">
        <h4 class="mb-10">{{ index }}.3.{{ category.index }} {{ category.name }}</h4>
        <p>Si riporta ripartizione dei consumi allocati alla macroarea {{ category.name }}</p>

        <table class="grid">
          <tr>
            <td class="col-small">
              <div class="pie-wrap">
                <apexchart type="pie" :options="category.pie_options" :series="category.pie_data" />
              </div>
            </td>
            <td class="report-arrow"><img src="/static/report/arrow.png"></td>
            <td class="col-small2">
              <b-table class="last-bold" :fields="fields" :items="category.items">
                <template slot="color" slot-scope="row">
                  <span v-if="! row.item.isTotal" class="legend" :style="{ color: $store.state.colors[row.index] }">■</span>
                </template>
              </b-table>
            </td>
          </tr>
        </table>

        <apexchart type="bar" :options="category.bar_options" :series="category.bar_series" />

        <ripartizione-charts :vector="vector" :index="index" :month="month" :siteGuid="siteGuid" :channel="channel" v-for="channel in category.subchannels" :key="channel.code" />
      </div>
    </div>
  </section>
</template>

<script>

import RipartizioneCharts from './G1_RipartizioneCharts'

var moment = require('moment');

export default {
  name: "Ripartizione",
  props: ['siteGuid', 'month', 'index', 'vector'],
  components: { RipartizioneCharts },

  data() {
    return {
      show_all: false,
      categories_data: [
        { value: 1, text: 'Attività' },
        { value: 2, text: 'Servizi ausiliari' },
        { value: 3, text: 'Servizi generali' },
        { value: 4, text: 'Altro' }
      ],
      categories: [],
      pie_options: {
        colors: this.$store.state.colors,
        chart: {
          animations: { enabled: false },
          width: 300,
        },
        labels: [],
        legend: { show: false }
      },
      pie_data: [],
      currentYear: 0,
      channels: [],
      allChannels: [],
      items: [],
      fields: [{ key: "color", label: "" }, { key: "name", label: "" }, { key: "value", label: this.vectorMu() }],
      c_index: 1,
      bar_options: {
        colors: this.$store.state.colors,
        chart: {
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          },
          stacked: true,
          height: 300,
          width: 940,
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            formatter: (v) => this.f(v)
          }
        },
      },
      subchannels: []
    }
  },

  created() {

    this.categories_data.forEach(c => {
      this.categories.push({
        id: c.value,
        name: c.text,
        channels: [],
        pie_options: {},
        pie_data: [],
        bar_options: {},
        bar_series: [],
        subchannels: []
      })
    })

    this.currentYear = parseInt(moment(this.month, 'MM-YYYY').format('YYYY'))
    this.allChannels = this.$store.state.user.sites.find(s => s.guid == this.siteGuid).channels

    this.categories.forEach(c => {
      let parent = this.allChannels.find(ch => ch.category == c.id)

      if(parent) {
        let params = {
          fromMonth: '01-' + this.currentYear,
          toMonth: '12-' + this.currentYear,
          siteGuid: this.siteGuid,
          vector: this.vector,
          categoryId: parent.category
        }


        this.$store.dispatch('charts/monthlyTepCategory', params).then( (response) => {
          if(! response.data) {
            this.$notify({
              type: "error",
              text: response.message,
              title: 'Errore',
            });
            return;
          }

          let data = response.data;

          if(data.values.length > 0) {
            c.show = true
            this.show_all = true

            this.$store.dispatch('report/setVectorDetails', { vector: this.vector, details: true })

            c.index = this.c_index++

            let pie_options = _.cloneDeep(this.pie_options)
            pie_options.labels = data.channels
            c.pie_options = pie_options

            var curData = _.filter(data.values, v => v[1] == this.month)

            var total = 0
            curData.forEach(v => {
              c.pie_data.push(v[2])
              total += v[2]
            })

            c.items = curData.map(v => {
              return {
                name: v[0],
                value: this.f(v[2]),
                code: this.allChannels.find(c => c.name == v[0]).code
              }
            })
            c.subchannels = c.items.map(v => v)
            c.items.push({
              name: "Totale",
              value: this.f(total),
              isTotal: true
            })

            c.bar_series = data.channels.map(channel => { return { name: channel, data: [] } })

            let bar_options = _.cloneDeep(this.bar_options)
            for(let i=1; i<=12; i++) {
              var month = i.toString().padStart(2, "0") + "-" + this.currentYear
              bar_options.xaxis.categories.push(moment(month, "MM-YYYY").format("MMM"))

              data.channels.forEach(channel => {
                var item = data.values.find(e => e[1] == month && e[0] == channel)
                if(item) {
                  var serie = c.bar_series.find(s => s.name == channel)
                  serie.data.push(item[2] ? item[2] : null)
                }
              })
            }
            c.bar_options = bar_options

            c.channels = _.filter(this.allChannels, ch => ch.parent_code == parent.code)

          }
        })
      }
    })
  },

  methods: {
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
    vectorMu() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).mu
    }
  },

  computed: {
    vectorName() {
      return this.$store.state.vectors.list.find(v => v.code == this.vector).name
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Report/G_Ripartizione.vue